module.exports = __webpack_public_path__ + "static/media/ep3.8275ac64.png";